import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Transition as _Transition } from "vue"

import { reactive, ref, watch, Ref, computed, toRefs } from 'vue';
import side from '@c/public/side/side.vue'
import pageHeader from '@c/public/pageHeader/pageHeader.vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { whiteList } from './util/class/common';
import { ArrowLeft, ArrowRight, Back, DArrowLeft, DArrowRight, Right } from '@element-plus/icons-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()
const store = useStore();
const menu = computed(() => store.state.menuList)
const state = reactive({
	isShowSide: true
})
const {
	isShowSide
} = toRefs(state)

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, {
    direction: "vertical",
    class: "layout h-100"
  }, {
    default: _withCtx(() => [
      (!_unref(whiteList).includes(_unref(route).name as string))
        ? (_openBlock(), _createBlock(pageHeader, { key: 0 }, {
            title: _withCtx(() => [
              _createElementVNode("div", {
                class: "showHideSide",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (isShowSide.value = !_unref(isShowSide)))
              }, [
                (!_unref(isShowSide))
                  ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(DArrowRight))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(DArrowLeft))
                      ]),
                      _: 1
                    }))
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_container, { class: "over-hide" }, {
        default: _withCtx(() => [
          (!_unref(whiteList).includes(_unref(route).name as string) && _unref(isShowSide))
            ? (_openBlock(), _createBlock(_component_el_aside, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(side, { menu: menu.value }, null, 8, ["menu"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_main, null, {
            default: _withCtx(() => [
              _createVNode(_Transition, { name: "slide-fade" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_view)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})